const fb = require('../firebase.js');
const { Message } = require("../classes/Message.js");
import store from '../store';


class ListeMessages {
    constructor() {
        this.liste = [];
    }
    async getMessages() {
        const query = await fb.db.collection("messages").get();
        const resultats = [];
        query.forEach(async doc => {
            resultats.push(new Message(doc.id, doc.data().content, doc.data().fullDate, doc.data().fullName, doc.data().mail, doc.data().sujet));
        });
        this.liste = resultats
        store.commit("setListeMessages", this);
    }
}

export default ListeMessages;